import { attachPropertiesToComponent } from "@hudiemon/utils";
import SelectMember from "./SelectMember";
import open from "./open";

export default attachPropertiesToComponent(SelectMember, {
  open,
});
